/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSearchCondition
 */
export interface GetSearchCondition {
    /**
     * 検索キーワードID
     * @type {number}
     * @memberof GetSearchCondition
     */
    id: number;
    /**
     * 検索キーワード
     * @type {string}
     * @memberof GetSearchCondition
     */
    keyword: string;
}

export function GetSearchConditionFromJSON(json: any): GetSearchCondition {
    return GetSearchConditionFromJSONTyped(json, false);
}

export function GetSearchConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSearchCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'keyword': json['keyword'],
    };
}

export function GetSearchConditionToJSON(value?: GetSearchCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'keyword': value.keyword,
    };
}

